import React, { useEffect, useState } from "react";
import { getFilesForCategory, getUserCategoriesFromPostgresqlApi } from "../../api";

// Define the props interface correctly
interface FileListByCategoryProps {
    username: string;
    setFileData: React.Dispatch<React.SetStateAction<{ [key: string]: string[] }>>; // This is the function to update state in parent
}

const FileListByCategory: React.FC<FileListByCategoryProps> = ({ username, setFileData }) => {
    // State to hold the list of files for each category that is available for a user
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        const fetchFiles = async () => {
            if (!username) username = "";
            try {
                // Fetch categories for the user
                const categories = await getUserCategoriesFromPostgresqlApi(username);
                // Initialize an object to hold files by category
                const categoryFiles: { [key: string]: string[] } = {};
                // Fetch files for each category
                await Promise.all(
                    categories.map(async category => {
                        categoryFiles[category] = await getFilesForCategory(category);
                    })
                );
                // Update the state with the fetched files
                setFileData(categoryFiles); // Pass the data to the parent component
            } catch (err) {
                setError(String(err));
                console.error("Error fetching files:", err);
            } finally {
                setLoading(false);
            }
        };

        // Fetch files when the component mounts or when the username changes
        fetchFiles();
    }, [username, setFileData]);

    if (loading) return <p>Loading...</p>;
    if (error) return <p style={{ color: "red" }}>{error}</p>;

    return null; // Don't render anything, parent handles the display of the files
};

export default FileListByCategory;
